import React from 'react';
import {Box, Flex, FormLabel, Text} from '@chakra-ui/react';
import {get} from '../../service/ApiService';
import {Client} from '../../service/Urls';
import Select from 'react-select';
import {useQuery} from 'react-query';
import {Controller} from 'react-hook-form';

export default function ClientSelectInput({
  name,
  control,
  required,
  isReadOnly,
  setClId,
}: {
  name: string;
  control: any;
  required?: boolean;
  isReadOnly?: boolean;
  setClId?: (val: string) => void;
}) {
  const {data, isLoading} = useQuery(['client', 'clientList'], () => get(Client.LIST + '?PageSize=1000'));

  const clients =
    data?.data?.map(client => ({
      value: client?.id,
      label: `${client?.clId} | ${client?.clCname ?? ''}`,
    })) ?? [];

  return (
    <Controller
      name={name}
      control={control}
      rules={{required}}
      render={({field: {value, onChange, ...rest}, fieldState: {error}}) => {
        return (
          <Flex mx={1}>
            <Box w="100%">
              <FormLabel fontSize="sm" mb="-0.5" ml="1">
                Select Client
              </FormLabel>
              <Select
                {...rest}
                value={clients?.find(client => client.value === value) ?? null}
                onChange={(newValue, actionMeta) => {
                  if (setClId) {
                    setClId(newValue?.label?.split(' ')[0]);
                  }
                  onChange(newValue?.value, actionMeta);
                }}
                options={clients}
                isDisabled={isReadOnly}
                isLoading={isLoading}
              />

              {error && (
                <Text color="red.400" fontSize="sm">
                  * Client is required
                </Text>
              )}
            </Box>
          </Flex>
        );
      }}
    />
  );
}
